import React, { useEffect, useRef, useState } from 'react';
import { Container, Input, FormGroup, Label } from 'reactstrap';
import AddUser from './AddUser';
import UpdateViewUser from './UpdateViewUser';
import TableRoot from './tables/TableRoot';
import Shimmer from 'commonComponents/Shimmer';
import DeleteModel from 'commonComponents/DeleteModel';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserById, fetchUserList } from './redux/dispatcher';
import apiEndpoints from 'utils/apiList';
import useDebouncedEffect from 'commonComponents/DeboucedEffect';

function Index() {
    const dispatch = useDispatch();
    const userList = useSelector((state) => state.userListReducer);
    const [loginUserType, setLoginUserType] = useState(useSelector((state) => state.authReducer).data?.user?.role)
    const [searchQuery, setSearchQuery] = useState('');
    const [isUpdate, setIsUpdate] = useState(false);
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [singleUserData, setSingleUserData] = useState(null);
    const [currentPage, setCurrentPage] = useState(userList?.data?.currentPage || 1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [selectedRoleType, setSelectedRoleType] = useState('rt');
    const [deleteItemId, setDeleteItemId] = useState('')
    const isLoading = useSelector((state) => state.userListReducer.isLoading);
    const [totalPages, setTotalPages] = useState(userList?.data?.pagination?.totalPages || 1)
    const skipInitialDebouncedFetchRef = useRef(true)

    useEffect(() => {
        setTotalPages(userList?.data?.pagination?.totalPages || 1)
        setCurrentPage(userList?.data?.currentPage || 1)
    }, [userList?.data?.pagination?.totalPages])

    useEffect(() => {
        dispatch(fetchUserList({ searchQuery: '', selectedRoleType: selectedRoleType === 'rt' ? null : selectedRoleType, currentPage, rowsPerPage }));
    }, [dispatch, selectedRoleType, currentPage]);

    useDebouncedEffect(() => {
        if (skipInitialDebouncedFetchRef.current) {
            skipInitialDebouncedFetchRef.current = false;
            return;
        }

        dispatch(fetchUserList({ searchQuery, selectedRoleType: selectedRoleType === 'rt' ? null : selectedRoleType, currentPage, rowsPerPage }));
    }, [searchQuery, rowsPerPage], 1000);

    useEffect(() => {
        if (userList?.selectedUser) {
            setSingleUserData(userList.selectedUser);
        }
    }, [userList?.selectedUser]);

    useEffect(() => {
        setCurrentPage(userList?.data?.currentPage || 1)
    }, [userList?.data?.currentPage])
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleRoleTypeChange = (event) => {
        setSelectedRoleType(event.target.value);
    };

    const handleEdit = (id) => {
        dispatch(fetchUserById(id, setIsUpdate));
    };

    const handleDelete = (id) => {
        setDeleteItemId(id)
        setIsDelete(true);
    };

    const handleView = (id) => {
        dispatch(fetchUserById(id, setIsViewOnly));
    };

    const tableData = userList?.data?.data || [];

    return (
        <>
            {/* <div className="" */}
            <div className="col-12 d-flex justify-content-end stickyFilter">
                <Container fluid>
                    <div className="d-flex flex-row justify-content-end mt-4 mb-3">
                        <FormGroup className="mr-3">
                            <Label for="roleType" hidden>Role Type</Label>
                            <Input
                                type="select"
                                name="roleType"
                                id="roleType"
                                value={selectedRoleType}
                                onChange={handleRoleTypeChange}
                                style={{ width: '240px' }}
                            >
                                {selectedRoleType === "rt" && (
                                    <option value="rt" disabled hidden >Select Role Type</option>
                                )}

                                {loginUserType === 'super_admin' && (
                                    <>
                                        <option value="">All</option>
                                        <option value="enterprise_admin">Enterprise Admin</option>
                                        <option value="regional_admin">Regional Admin</option>
                                        <option value="company_admin">Company Admin</option>
                                        <option value="fluid_handler">Fluid Handler</option>
                                    </>
                                )}
                                {loginUserType === 'enterprise_admin' && (
                                    <>
                                        <option value="">All</option>
                                        <option value="regional_admin">Regional Admin</option>
                                        <option value="company_admin">Company Admin</option>
                                        <option value="fluid_handler">Fluid Handler</option>
                                    </>
                                )}
                                {(loginUserType === 'zone_admin' || loginUserType === 'regional_admin') && (
                                    <>
                                        <option value="">All</option>
                                        <option value="company_admin">Company Admin</option>
                                        <option value="fluid_handler">Fluid Handler</option>
                                    </>
                                )}
                                {loginUserType === 'company_admin' && (
                                    <>
                                        <option value="fluid_handler">Fluid Handler</option>
                                    </>
                                )}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mr-3">
                            <Label for="searchInput" hidden>Search</Label>
                            <div style={{ position: 'relative', width: "230px", display: 'inline-block' }}>
                                <Input
                                    type="text"
                                    id="searchInput"
                                    value={searchQuery}
                                    onChange={(e) => {
                                        handleSearchChange(e);
                                        setCurrentPage(1);
                                    }}
                                    placeholder="Search by Name"
                                    style={{ width: "100%", paddingRight: "30px" }}
                                />
                                {searchQuery && (
                                  <i
                                    className="fa-solid fa-xmark"
                                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => {
                                      setSearchQuery("");
                                      setCurrentPage(1);
                                    }}
                                  ></i>
                                )}
                            </div>
                        </FormGroup>

                        <div>
                            {isUpdate || isViewOnly ? (
                                <UpdateViewUser
                                    isViewOnly={isViewOnly}
                                    setIsUpdate={setIsUpdate}
                                    setIsViewOnly={setIsViewOnly}
                                    data={singleUserData}
                                    selectedRoleType={selectedRoleType}
                                    searchQuery={searchQuery}
                                />
                            ) : (
                                <AddUser />
                            )}
                            {isDelete && <DeleteModel setIsDelete={setIsDelete} id={deleteItemId} apiEndpoint={apiEndpoints.USER_DELETE} flagName={'userList'} setSearchQuery={setSearchQuery} setSelectedRoleType={setSelectedRoleType} />}
                        </div>
                    </div>
                </Container>
            </div>
            {/* </div> */}

            <div>
                {isLoading ? (
                    <Shimmer />
                ) : (
                    <TableRoot
                        header={['Sr. No.', 'Name', 'User Id', 'Company', 'Role', 'Status', 'Action']}
                        tableData={tableData}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        handleView={handleView}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                        setRowsPerPage={setRowsPerPage}
                        roweperpage={rowsPerPage}
                    />
                )}
            </div>
        </>
    );
}

export default Index;
